import { get } from 'lodash'

export const getCurrentConfiguration = (state) => get(state, 'config')

export const getDeviceSubtype = (state) => get(state, 'config.deviceSubtype')

export const getIsPrintController = (state) => get(state, 'config.isPrintController', false)

export const getSelectedMenusIds = (state) => state?.config?.configuration?.menuUuids ?? []
